"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupItem = void 0;
var PopupItem = /** @class */ (function () {
    function PopupItem(ComponentClass, props, guid) {
        this.ComponentClass = ComponentClass;
        this.props = props;
        this.guid = guid;
        this._isOpen = true;
    }
    Object.defineProperty(PopupItem.prototype, "isOpen", {
        get: function () {
            return this._isOpen;
        },
        enumerable: false,
        configurable: true
    });
    PopupItem.prototype.close = function () {
        this._isOpen = false;
    };
    return PopupItem;
}());
exports.PopupItem = PopupItem;
//# sourceMappingURL=PopupItem.js.map